import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { Menu, X } from "lucide-react";
import MetaStrip from "./MetaStrip";

const NAV_LINKS = [
  { label: "Labs", href: "#labs" },
  { label: "Studio", href: "#studio" },
  { label: "Openings", href: "#openings" },
  { label: "Shop", href: "#shop" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header className="lg:absolute lg:top-0 lg:left-0 lg:right-0 relative z-30 w-full">
      <div className="w-full px-6 lg:px-10 py-5 flex items-center justify-between">
        <a
          href="#"
          className="text-[#1C2E1E] text-xl md:text-2xl font-semibold tracking-tight cursor-pointer whitespace-nowrap"
        >
          Mainframe<span className="align-super text-xs">®</span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm text-[#1C2E1E] hover:text-[#5A635A] transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <a
            href="#contact"
            className="px-5 py-2.5 rounded-full bg-[#1C2E1E] text-white text-sm font-medium hover:bg-[#2a4030] transition-colors cursor-pointer whitespace-nowrap"
          >
            Get in touch
          </a>
        </div>

        <button
          type="button"
          aria-label="Open menu"
          onClick={() => setMenuOpen(true)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-[#1C2E1E] cursor-pointer"
        >
          <Menu className="w-6 h-6" />
        </button>
      </div>

      {/* Decorative editorial meta strip — hairlines, ticks, status dot, coords */}
      <MetaStrip />

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-50 bg-white/90 backdrop-blur-xl flex flex-col lg:hidden"
          >
            <div className="flex items-center justify-between px-6 py-5">
              <span className="text-xl font-semibold text-[#1C2E1E]">
                Mainframe<span className="align-super text-xs">®</span>
              </span>
              <button
                type="button"
                aria-label="Close menu"
                onClick={() => setMenuOpen(false)}
                className="w-10 h-10 flex items-center justify-center text-[#1C2E1E] cursor-pointer"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <nav className="flex-1 flex flex-col items-center justify-center gap-8 px-6">
              {NAV_LINKS.map((link, i) => (
                <motion.a
                  key={link.label}
                  href={link.href}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.05 * i, duration: 0.3 }}
                  onClick={() => setMenuOpen(false)}
                  className="text-3xl font-semibold text-[#1C2E1E] cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </motion.a>
              ))}

              <motion.a
                href="#contact"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.25, duration: 0.3 }}
                onClick={() => setMenuOpen(false)}
                className="mt-6 px-6 py-3 rounded-full bg-[#1C2E1E] text-white text-base font-medium cursor-pointer whitespace-nowrap"
              >
                Get in touch
              </motion.a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}